import Vue from 'vue'
import Vuex from 'vuex'

import global from '@/store/modules/global'
import data from '@/store/modules/data'
import user from '@/store/modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    global,
    user,
    data
  }
})